import React, { useState, useEffect, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { LuBell } from "react-icons/lu";
import { LuSearch } from "react-icons/lu";
import { RiDeleteBinLine } from "react-icons/ri";
import {
  MdOutlineNotificationsActive,
  MdOutlineNotificationsNone,
} from "react-icons/md";
import * as apicall from "../Apicall";
import { TbLogout } from "react-icons/tb";
import { MdPersonOutline } from "react-icons/md";
import { IoIosHelpCircle } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import * as constants from "../../constants/Constants";

const Navbar = ({ toggleSidebar, vendorDataPass }) => {
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [loading, setLoading] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const [support, setSupport] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [deletedNotif, setdeletedNotif] = useState([]);
  const bellRef = useRef(null);
  const supportRef = useRef(null);
  const [setupCompleted, setSetupCompleted] = useState(
    localStorage.getItem("setupCompleted") === "true"
  );
  const vendorId = localStorage.getItem("vendorId");
  const [vendorLogo, setVendorLogo] = useState(null);
  const pollingInterval = useRef(null);
  const [hoveredDelete, setHoveredDelete] = useState(null);
  const [helpLink, setHelpLink] = useState(null);

  // Store read status in localStorage to persist between refreshes
  const [readNotifications, setReadNotifications] = useState(() => {
    const saved = localStorage.getItem("readNotifications");
    return saved ? JSON.parse(saved) : [];
  });

  // Store deleted notifications to prevent showing them again
  const [deletedNotifications, setDeletedNotifications] = useState(() => {
    const saved = localStorage.getItem("deletedNotifications");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem(
      "readNotifications",
      JSON.stringify(readNotifications)
    );
    localStorage.setItem(
      "deletedNotifications",
      JSON.stringify(deletedNotifications)
    );
  }, [readNotifications, deletedNotifications]);

  // Add polling mechanism
  useEffect(() => {
    const startPolling = () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
      }
      pollingInterval.current = setInterval(() => {
        if (vendorId) {
          fetchNotifications(vendorId);
        }
      }, 30000);
    };

    startPolling();

    return () => {
      if (pollingInterval.current) {
        clearInterval(pollingInterval.current);
      }
    };
  }, [vendorId]);

  useEffect(() => {
    const fetchVendorProfile = async () => {
      try {
        const [response, help_link] = await Promise.all([
          apicall.get("ezpMyProfile"),
          apicall.get("get_ezp_help"),
        ]);

        if (response.status === 200 && response.success) {
          const vendorData = response.data[0];
          console.log(vendorData,"vendorData")
          localStorage.setItem("vendorProfile", JSON.stringify(vendorData));

          localStorage.setItem("vendorId", vendorData.vendor_id);
          localStorage.setItem("currency", vendorData.currency || "INR");
          setVendorName(vendorData.first_name);
          setVendorLogo(vendorData.vendor_logo);
          // Initial fetch of notifications
          fetchNotifications(vendorData.vendor_id);
          vendorDataPass(vendorData);
        }
        setHelpLink(help_link?.data[0]?.link);
      } catch (error) {
        console.error("Error fetching vendor profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVendorProfile();
  }, []);

  const fetchNotifications = async (vendorId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        constants.apiUrl + "api/v1/notificationsVendor/" + vendorId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 401) {
        // Do NOT refresh token, just return empty
        return [];
      }

      if (!response.ok) {
        throw new Error("Failed to fetch notifications");
      }

      const data = await response.json();
      if (data.status === 200 && data.success) {
        // Filter out deleted notifications and merge with local read status
        const updatedNotifications = data.data
          .filter((notif) => !deletedNotifications.includes(notif.id))
          .map((notif) => ({
            ...notif,
            is_read: readNotifications.includes(notif.id) ? 1 : notif.is_read,
          }));

        // Only update if there are changes
        if (
          JSON.stringify(notifications) !== JSON.stringify(updatedNotifications)
        ) {
          setNotifications(updatedNotifications);
          setUnreadCount(
            updatedNotifications.filter((n) => n.is_read === 0).length
          );
        }
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const markNotificationAsRead = async (id) => {
    try {
      // Optimistically update UI first
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, is_read: 1 } : n))
      );
      setReadNotifications((prev) => [...prev, id]);
      setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));

      // Then update the API
      await apicall.get(`notificationVendor_readStatus/${id}`);
    } catch (error) {
      console.error("Error marking notification as read:", error);
      // Rollback if API call fails
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, is_read: 0 } : n))
      );
      setReadNotifications((prev) => prev.filter((notifId) => notifId !== id));
      setUnreadCount((prev) => prev + 1);
    }
  };

  const deleteNotification = async (id) => {
    try {
      // Optimistically update UI first
      const deletedNotif = notifications.find((n) => n.id === id);
      setNotifications((prev) => prev.filter((n) => n.id !== id));
      setDeletedNotifications((prev) => [...prev, id]);

      if (deletedNotif && deletedNotif.is_read === 0) {
        setUnreadCount((prev) => (prev > 0 ? prev - 1 : 0));
      }

      // Then update the API
      await apicall.get(`notificationVendor_delete/${id}`);
    } catch (error) {
      console.error("Error deleting notification:", error);
      // Rollback if API call fails
      if (deletedNotif) {
        setNotifications((prev) => [...prev, deletedNotif]);
        setDeletedNotifications((prev) =>
          prev.filter((notifId) => notifId !== id)
        );
        if (deletedNotif.is_read === 0) {
          setUnreadCount((prev) => prev + 1);
        }
      }
    }
  };

  const deleteAllNotifications = async () => {
    try {
      // Optimistically update UI first
      const unreadToDelete = notifications.filter(
        (n) => n.is_read === 0
      ).length;
      const allIds = notifications.map((n) => n.id);

      setNotifications([]);
      setDeletedNotifications((prev) => [...prev, ...allIds]);
      setUnreadCount((prev) =>
        prev - unreadToDelete > 0 ? prev - unreadToDelete : 0
      );

      // Then update the API
      await Promise.all(
        notifications.map((notif) =>
          apicall.get(`notificationVendor_delete/${notif.id}`)
        )
      );
    } catch (error) {
      console.error("Error deleting all notifications:", error);
      // Full rollback is complex here, might want to just refresh notifications
      fetchNotifications(vendorId);
    }
  };

  // Close popup when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (supportRef.current && !supportRef?.current.contains(event.target)) {
        setSupport(false);
      }
    }
    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    if (support) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications, support]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const handleSearchSubmit = (e) => {
    if (e.key === "Enter" && searchQuery.trim()) {
      navigate("/doctors", { state: { searchQuery: searchQuery.trim() } });
      setShowSearch(false);
      setSearchQuery("");
    }
  };
  async function checkSetupStatus() {
    try {
      let [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking,
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_types`),
        apicall.get(`get_ezp_service_providers`),
        apicall.get(`get_ezp_booking?page=1&limit=1`),
      ]);

      let ans = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0,
      };

      let totalPercentage = Object.values(ans).filter((val) => val).length * 20;

      const completed = totalPercentage === 100;

      localStorage.setItem("setupCompleted", completed ? "true" : "false");
      localStorage.setItem(
        "userDetails",
        JSON.stringify(ezpMyProfile?.data?.[0])
      );

      setSetupCompleted(completed);
    } catch (e) {
      console.log("Setup status error", e);
    }
  }
  useEffect(() => {
    checkSetupStatus();
  }, []);
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top custom-border-bottom py-2">
      <div className="container-fluid px-3 px-lg-4 d-flex justify-content-between align-items-center navbar-responsive">
        <div className="d-flex align-items-center flex-shrink-0">
          {" "}
          {/* <img
            src={vendorLogo ? vendorLogo : utilstopAppointmentLogo}
            // src={utilstopAppointmentLogo}
            alt={vendorName || "vendor Name"}
            style={{ width: "150px", height: "50px" }}
          /> */}
          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-2"
            style={{
              width: "32px",
              height: "32px",
              overflow: "hidden",
              backgroundColor: vendorLogo ? "transparent" : "#1D4ED8",
            }}
          >
            {vendorLogo ? (
              <img
                src={vendorLogo}
                alt={vendorName}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <span className="text-white fw-bold">
                {vendorName?.charAt(0) || ""}
              </span>
            )}
          </div>
          <div className="d-flex flex-column">
            <span className="fw-bold" style={{ fontSize: "16px" }}>
              {vendorName}
            </span>

            <div style={{ fontSize: "12px" }}>
              <span className="text-muted">Free Plan</span>

              <span className="mx-1">|</span>

              <span
                style={{
                  color: "#1D4ED8",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
                onClick={() => navigate("/pricing")}
              >
                Pro
              </span>
            </div>
            {/* <div
              className="text-muted d-flex align-items-center"
              style={{ fontSize: "12px" }}
            >
              <span>By</span>
              <img
                src={utilstopAppointmentLogo}
                alt="UtilStop"
                style={{ height: "16px", marginLeft: "4px" }}
              />
            </div> */}
          </div>
        </div>

        {/* Right Side Items */}
        <div className="d-flex align-items-center gap-2 flex-nowrap">
          {/* Search Bar */}
          {/* <div className="d-none d-md-block navbar-search-bar">
            <div
              className="position-relative"
              style={{
                width:
                  typeof window !== "undefined" &&
                  window.innerWidth >= 768 &&
                  window.innerWidth <= 1024
                    ? showSearch
                      ? "200px"
                      : "44px"
                    : showSearch
                    ? "320px"
                    : "44px",
              }}
            >
              <LuSearch
                onClick={() => setShowSearch((prev) => !prev)}
                className="position-absolute"
                style={{
                  left: "16px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#000",
                  cursor: "pointer",
                  zIndex: 2,
                }}
              />
              <input
                type="text"
                className={`form-control ps-5 ${showSearch ? "" : "d-none"}`}
                placeholder="Search for doctors"
                value={searchQuery}
                onChange={handleSearch}
                onKeyDown={handleSearchSubmit}
                autoFocus={showSearch}
                style={{
                  borderRadius: "8px",
                  height: "44px",
                  backgroundColor: "#F5F5F5",
                  border: "none",
                  fontSize: "14px",
                }}
              />
            </div>
          </div> */}
          {setupCompleted ? (
            <span
              style={{
                color: "green",
                fontWeight: "600",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => navigate("/vendor_bookings")}
            >
              Start Booking
            </span>
          ) : (
            <span
              style={{
                color: "#F59E0B",
                fontWeight: "600",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => navigate("/setup")}
            >
              Setup Incomplete
            </span>
          )}

          <div className="position-relative" ref={supportRef}>
            <BiSupport
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={() => setSupport((prev) => !prev)}
            />
            {support && (
              <div
                style={{
                  position: "fixed",
                  top: "63px",
                  right: "12px",
                  // width: "420px",
                  maxHeight: "calc(100vh - 63px)",
                  background: "#fff",
                  borderLeft: "1px solid #E3EBF8",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  zIndex: 2000,
                  overflowY: "auto",
                  padding: "16px",
                }}
              >
                <div>Email: support@utilstop.com</div>
              </div>
            )}
          </div>

          {helpLink && (
            <a
              style={{ color: "#000" }}
              href={helpLink}
              target="_blank"
              rel="noreferrer"
              alt="help tutorial"
            >
              <IoIosHelpCircle style={{ width: "24px", height: "24px" }} />
            </a>
          )}

          <div className="position-relative" ref={bellRef}>
            <LuBell
              style={{ fontSize: "20px", color: "#000", cursor: "pointer" }}
              onClick={() => setShowNotifications((prev) => !prev)}
            />
            {unreadCount > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                style={{ fontSize: "10px", padding: "4px 6px" }}
              >
                {unreadCount}
              </span>
            )}
            {showNotifications && (
              <div
                style={{
                  position: "fixed",
                  top: "63px",
                  right: 0,
                  width: "420px",
                  maxHeight: "calc(100vh - 63px)",
                  background: "#fff",
                  borderLeft: "1px solid #E3EBF8",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  zIndex: 2000,
                  overflowY: "auto",
                  padding: "16px",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span style={{ fontWeight: 600 }}>Notifications</span>
                  {notifications.length > 0 && (
                    <button
                      className="btn btn-link p-0"
                      style={{
                        fontSize: "13px",
                        color: "#1D4ED8",
                        textDecoration: "none",
                      }}
                      onClick={deleteAllNotifications}
                    >
                      Clear All
                    </button>
                  )}
                </div>

                {notifications.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#888",
                      marginTop: "40px",
                    }}
                  >
                    You are yet to receive notifications.
                  </div>
                ) : (
                  <div>
                    {notifications.map((notif) => (
                      <div
                        key={notif.id}
                        style={{
                          borderBottom: "1px solid #eee",
                          padding: "12px 0",
                          cursor: "pointer",
                          backgroundColor:
                            notif.is_read === 0 ? "#f8f9fa" : "transparent",
                          position: "relative",
                        }}
                        onClick={() => {
                          if (notif.is_read === 0) {
                            markNotificationAsRead(notif.id);
                          }
                          // Add navigation based on redirection if needed
                          // navigate(`/${notif.redirection}/${notif.reference_id}`);
                        }}
                      >
                        <div
                          style={{ display: "flex", alignItems: "flex-start" }}
                        >
                          <div
                            style={{ paddingLeft: "10px", marginRight: "10px" }}
                          >
                            {notif.is_read === 0 ? (
                              <MdOutlineNotificationsActive
                                style={{ color: "#C9194A", fontSize: "20px" }}
                              />
                            ) : (
                              <MdOutlineNotificationsNone
                                style={{ color: "#888", fontSize: "20px" }}
                              />
                            )}
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 600 }}>{notif.title}</div>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#555",
                                paddingRight: "10px",
                              }}
                            >
                              {notif.message}
                            </div>

                            <div
                              style={{
                                fontSize: "11px",
                                color: "#aaa",
                                marginTop: "2px",
                              }}
                            >
                              {new Date(notif.created).toLocaleString()}
                            </div>
                          </div>
                          <button
                            className="btn btn-link p-0"
                            style={{
                              color:
                                hoveredDelete === notif.id ? "red" : "#dc3545",
                              position: "absolute",
                              right: "10px",
                              top: "0px",
                              transition: "color 0.2s ease",
                            }}
                            onMouseEnter={() => setHoveredDelete(notif.id)}
                            onMouseLeave={() => setHoveredDelete(null)}
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteNotification(notif.id);
                            }}
                          >
                            <RiDeleteBinLine
                              style={{
                                fontSize: "18px",
                                transform:
                                  hoveredDelete === notif.id
                                    ? "scale(1.1)"
                                    : "scale(1)",
                                transition: "transform 0.2s ease",
                              }}
                            />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>

          <Dropdown align="end" className="d-flex align-items-center">
            <Dropdown.Toggle
              variant="link"
              className="p-0 border-0 bg-transparent d-flex align-items-center custom-dropdown-toggle"
              id="dropdown-user"
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center me-2"
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#1D4ED8",
                  fontSize: "16px",
                }}
              >
                <span className="text-white">{vendorName.charAt(0)}</span>
              </div>
            </Dropdown.Toggle>

            <style jsx="true">{`
              .custom-dropdown-toggle::after {
                display: none !important;
              }
              /* Force dropdown to appear on top of other elements on mobile */
              @media (max-width: 768px) {
                .dropdown-menu {
                  position: fixed !important;
                  top: 10px !important; /* just below navbar */
                  width: 95% !important;
                  left: 20px;
                  max-width: 300px;
                  z-index: 3000;
                  border-radius: 8px;
                  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
              }
            `}</style>

            <Dropdown.Menu style={{ marginTop: "8px" }}>
              <Dropdown.Item
                onClick={() => navigate("/vendors/view-profile")}
                className="d-flex align-items-center gap-2"
              >
                <MdPersonOutline style={{ fontSize: "24px" }} />
                <span className="form-labels">Profile</span>
              </Dropdown.Item>

              <Dropdown.Item
                onClick={handleLogout}
                className="d-flex align-items-center gap-2"
              >
                <TbLogout style={{ fontSize: "24px" }} />
                <span className="form-labels">Sign-Out</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* Mobile Search */}
      {/* <div className="container-fluid px-3 d-md-none mt-2">
        <div
          className="position-relative"
          style={{ maxWidth: "320px", width: "100%" }}
        >
          <FaSearch
            className="position-absolute"
            style={{
              left: "16px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#8C8C8C",
            }}
          />
          <input
            type="text"
            className="form-control ps-5"
            placeholder="Search for doctors"
            value={searchQuery}
            onChange={handleSearch}
            onKeyDown={handleSearchSubmit}
            style={{
              borderRadius: "8px",
              height: "44px",
              backgroundColor: "#F5F5F5",
              border: "none",
              fontSize: "14px",
            }}
          />
        </div>
      </div> */}
      <style jsx="true">{`
        /* Mobile tweaks: shrink spacing, font sizes, icons */
        @media (max-width: 768px) {
          .navbar-responsive {
            flex-wrap: nowrap;
            overflow-x: auto;
          }
          .navbar-responsive > div,
          .navbar-responsive > div > span,
          .navbar-responsive > div > a {
            white-space: nowrap;
            font-size: 12px;
          }
          .support-popup {
            position: fixed;
            top: 63px;
            right: 12px;
            max-height: calc(100vh - 63px);
            background: #fff;
            border-left: 1px solid #e3ebf8;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            z-index: 2000;
            overflow-y: auto;
            padding: 12px;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
